import { auth } from 'api';
import { lsSetAuthToken, lsRemoveAuthToken } from 'helpers/store';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_VALIDATE
} from 'store/actions/auth';

export default {
  [AUTH_VALIDATE]: ({ dispatch, getters }) => {
    if (getters.isAuthenticated) {
      // TODO: Verificar aquí si el token es valido por el tiempo
      return Promise.resolve();
    }
    return dispatch(AUTH_REQUEST);
  },

  [AUTH_REQUEST]: ({ commit }) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      auth
        .startSessionApi({
          clientId: process.env.API_CLIENT_ID,
          clientSecret: process.env.API_CLIENT_SECRET,
          scope: process.env.API_SCOPE,
          grantType: process.env.API_GRANT_TYPE
        })
        .then(
          resp => {
            const data = resp.data;
            lsSetAuthToken(data);
            commit(AUTH_SUCCESS, data);
            resolve();
          },
          err => {
            commit(AUTH_ERROR, err);
            lsRemoveAuthToken();
            reject();
          }
        );
    }),

  [AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(AUTH_LOGOUT);
      lsRemoveAuthToken();
      resolve();
    })
};
